import { render } from "./InventoryBox.vue?vue&type=template&id=0553a50a&scoped=true&bindings={\"items\":\"props\",\"currentItem\":\"props\",\"actions\":\"props\",\"currentVerb\":\"props\",\"closeIcon\":\"data\",\"inventory\":\"options\",\"caption\":\"options\"}"
import script from "./InventoryBox.vue?vue&type=script&lang=js"
export * from "./InventoryBox.vue?vue&type=script&lang=js"

import "./InventoryBox.vue?vue&type=style&index=0&id=0553a50a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0553a50a"

export default script